<content>
    <section class="entry-inline-framed">
        <label>{{'global.pais' | translate }}:</label> {{pais.des}}
        <label>{{'mantenimientoEtiquetadores.marcas.denominacion' | translate }}</label>
        {{denominacion.des}}
        <label>{{'mantenimientoEtiquetadores.marcas.etiquetador' | translate }}</label> {{etiquetador.des}}
    </section>
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th class="short">{{'mantenimientoEtiquetadores.marcas.marca' | translate }}</th>
              <th class="short" *ngIf="this.role === 'Administrador'">{{'mantenimientoEtiquetadores.marcas.etiquetasCaja' | translate }}</th>
              <th class="short" *ngIf="this.role === 'Administrador'">{{'mantenimientoEtiquetadores.marcas.etiquetasPallet' | translate }}</th>
              <th class="short">{{'mantenimientoEtiquetadores.marcas.impresionAutorizada' | translate }}</th>
              <th class="short">{{'mantenimientoEtiquetadores.marcas.reimpresionAutorizada' | translate }}</th>
              <th class="actions">
                <i class="fas fa-plus" *ngIf="this.role === 'Administrador'" (click)="new=true;editables=''"
                title="{{'mantenimientoEtiquetadores.marcas.tituloNew' | translate}}"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <app-mepd-new-edit class="component-in-row" *ngIf="new" [editable]="true" [marcas]="marcasPaisDenominacion"
            [paisId]="paisId" [etiquetadorId]="etiquetadorId" [denominacionId]="denominacionId" (close)="new=$event" (refresh)="toRefresh($event)"
            (editableChanged)="editableChanged($event)" (pushMessage)="showMessages($event)"
            [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja" [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet">
            </app-mepd-new-edit>
            <app-mepd-new-edit class="component-in-row" *ngFor=" let etiquetador of etiquetadorMarcasPaisDenominacion" [marcas]="marcasPaisDenominacion"
            [editable]="etiquetador === editables" (editableChanged)="editableChanged($event)" (pushMessage)="showMessages($event)"
            [etiquetador]="etiquetador" [paisId]="paisId" [etiquetadorId]="etiquetadorId" [denominacionId]="denominacionId"
            [allGrupoEtiquetasCaja]="allGrupoEtiquetasCaja" [allGrupoEtiquetasPallet]="allGrupoEtiquetasPallet" (refresh)="toRefresh($event)"
            [grupoEtiquetasCaja]="getGruposEtiqueta(etiquetador, 1)" [grupoEtiquetasPallet]="getGruposEtiqueta(etiquetador, 2)">
            </app-mepd-new-edit>
          </tbody>
          <tfoot *ngIf="(!etiquetadorMarcasPaisDenominacion || (etiquetadorMarcasPaisDenominacion && etiquetadorMarcasPaisDenominacion.length < 1)) && !new">
            <tr>
              <td colspan="5">
                {{'global.noContent' | translate}}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
</content>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
